import { ReactElement } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { DELETE_BRANCH_REQUEST } from "../../redux/constants";
import { getAuthState } from "../../redux/selectors";

type Props = {
  visible: boolean;
  onClose: () => void;
  branch: any;
  club: string;
};

export function DeleteBranchModal({
  visible,
  onClose,
  branch,
  club,
}: Props): ReactElement {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(getAuthState);

  const onFinish = () => {
    dispatch({
      type: DELETE_BRANCH_REQUEST,
      payload: { branchId: branch.firestoreRef, club, currentUser },
    });
    onClose();
  };

  return (
    <Modal
      title="Confirm"
      centered
      visible={visible}
      onOk={onFinish}
      onCancel={onClose}
    >
      <p>Are you sure to delete {branch.location}</p>
    </Modal>
  );
}
